import firebase from 'firebase/app'
import 'firebase/messaging'

const firebaseConfig = {
  apiKey: 'AIzaSyADLHLyOHG46he_9n5bIqXXYRcUu_lE2G4',
  authDomain: 'mesa-3-stg.firebaseapp.com',
  databaseURL: 'https://mesa-3-stg.firebaseio.com',
  projectId: 'mesa-3-stg',
  storageBucket: '',
  messagingSenderId: '495512141513',
  appId: '1:495512141513:web:ebe745ade66a738e9c1718'
}

let messaging = null
if (
  firebase.messaging.isSupported() &&
  process.env.VUE_APP_ENABLE_FCM_NOTIFICATIONS === 'yes'
) {
  firebase.initializeApp(firebaseConfig)
  messaging = firebase.messaging()
}

export default messaging
